import { render, staticRenderFns } from "./PatientRegistrationForm.vue?vue&type=template&id=179cccaa&scoped=true"
import script from "./PatientRegistrationForm.vue?vue&type=script&lang=js"
export * from "./PatientRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179cccaa",
  null
  
)

export default component.exports